var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "custom-chip-field" }, [
    _c(
      "div",
      {
        staticClass: "custom-chip-trigger",
        class: { tappable: _vm.displayOnly },
        on: { click: _vm.onTriggerClick },
      },
      [
        _c(
          "Chip",
          {
            staticClass: "custom-chip",
            class: { active: _vm.showActiveRing },
            attrs: {
              chipValue: _vm.chipLabel,
              disabled: false,
              displayOnly: _vm.displayOnly,
            },
            on: { updateActiveChip: _vm.toggleEditCustom },
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/svg/chips/yellow.svg") },
            }),
            _c("span", { staticClass: "custom-chip-label" }, [
              _vm._v(
                " " + _vm._s(_vm.$t(_vm.customChip ? "" : "Custom")) + " "
              ),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm.editCustomChip
      ? _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.toggleEditCustom,
                expression: "toggleEditCustom",
              },
            ],
            staticClass: "custom-chip-input",
          },
          [
            _c("div", { staticClass: "label" }, [
              _vm._v(" " + _vm._s(_vm.$t("Maximum")) + " "),
              _c("br"),
              _vm._v(
                " " +
                  _vm._s(_vm.currencySymbol) +
                  " " +
                  _vm._s(_vm.formatAmountWithKM(Number(_vm.maxBet), 0)) +
                  " "
              ),
            ]),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customChip,
                    expression: "customChip",
                  },
                ],
                attrs: { type: "tel", pattern: "^[0-9]*$" },
                domProps: { value: _vm.customChip },
                on: {
                  blur: _vm.validtateInput,
                  keydown: _vm.blockNonDigit,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.customChip = $event.target.value
                  },
                },
              }),
            ]),
            _c(
              "div",
              {
                staticClass: "label-right",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.toggleEditCustom.apply(null, arguments)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }